import PubSub from "underpub-js";

var Collage = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-Collage',
	};

	$.extend(true, this.options, options);

};

Collage.prototype.init = function() {

	var self = this;

};

export default Collage;
